import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AuthModule } from './applicationModules/authentication/auth.module';
import { UserModule } from './applicationModules/users/user.module';
import { CoreModule } from './applicationModules/core/core.module';
import { SettingsModule } from './applicationModules/settings/settings.module';
import { AdminModule } from './applicationModules/admin/admin.module';
import { ESignatureModule } from './applicationModules/eSignature/eSignature.module';
import { FileManagerModule } from './applicationModules/file-manager/file-manager.module';
import { UnAuthenticateModule } from './unAuthenticatedModules/unAuthenticate.module';
import { ProcessIntelligenceModule } from './applicationModules/process-intelligence/process-intelligence.module';
import { ChatModule } from './applicationModules/chat/chat.module';
import { TaskModule } from './applicationModules/task/task.module';
import { WorkflowModule } from './applicationModules/workflow/workflow.module';
import { CalendarModule } from './applicationModules/calendar/calendar.module';
import { FacilityModule } from './applicationModules/facility/facility.module';
import { NotificationModule } from './applicationModules/notification/notification.module';
import { EcmAuthgaurdGuard } from './middleware/authentication/authgaurd/ecm-authgaurd.guard';
import { ErrorVerificationComponent } from './middleware/shared/errorVerifcation/components/errorVerification/error-verification.component';
import { ContactModule } from './applicationModules/contact/contact.module';
import { CompanyModule } from './applicationModules/company/company.module';
import { PageNotFoundComponent } from './middleware/common/pagenotfound/pagenotfound.component';
import { DashboardModule } from './applicationModules/dashboard/dashboard.module';
import { CalendarComponent } from './applicationModules/calendar/calendar.component';
import { OrganizationModule } from './applicationModules/organization/organization.module';
import { GroupListingTableComponent } from './middleware/common/group-listing-table/group-listing-table.component';
import { ReportsModule } from './applicationModules/reports/reports.module';
import { ResidentDashboardModule } from './applicationModules/residentdashboard/residentdashboard.module';
import { ResidentViewModule } from './applicationModules/residentview/residentview.module';
import { SfnReportingModule } from './applicationModules/sfnReporting/sfnReporting.module';


const routes: Routes = [
  {
    path: 'auth',
    loadChildren: './applicationModules/authentication/auth.module#AuthModule',
  },
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    loadChildren: './applicationModules/dashboard/dashboard.module#DashboardModule',
    canActivate: [EcmAuthgaurdGuard],
  },
   {
    path: 'residentdashboard',
    loadChildren: './applicationModules/residentdashboard/residentdashboard.module#ResidentDashboardModule',
    //canActivate: [EcmAuthgaurdGuard],
  },
  {
    path: 'residentview',
    loadChildren: './applicationModules/residentview/residentview.module#ResidentViewModule',
    //canActivate: [EcmAuthgaurdGuard],
  },
  {
    path: 'sfnReporting',
    loadChildren: './applicationModules/sfnReporting/sfnReporting.module#SfnReportingModule',
    //canActivate: [EcmAuthgaurdGuard],
  },
  {
    path: 'core',
    loadChildren: './applicationModules/core/core.module#CoreModule',
    canActivate: [EcmAuthgaurdGuard],
  },
  {
    path: 'contact',
    loadChildren: './applicationModules/contact/contact.module#ContactModule',
    canActivate: [EcmAuthgaurdGuard],
  },
  {
    path: 'company',
    loadChildren: './applicationModules/company/company.module#CompanyModule',
    canActivate: [EcmAuthgaurdGuard],
  },
  {
    path: 'esignature',
    loadChildren: './applicationModules/eSignature/eSignature.module#ESignatureModule',
    canActivate: [EcmAuthgaurdGuard],
  },
  {
    path: 'task',
    loadChildren: './applicationModules/task/task.module#TaskModule',
    canActivate: [EcmAuthgaurdGuard],
  },
  {
    path: 'workflow',
    loadChildren: './applicationModules/workflow/workflow.module#WorkflowModule',
    canActivate: [EcmAuthgaurdGuard],
  },
  {
    path: 'intelligence',
    loadChildren: './applicationModules/process-intelligence/process-intelligence.module#ProcessIntelligenceModule',
  },
  // {
  //   path: 'calendar',
  //   loadChildren: './applicationModules/calendar/calendar.component',
  //  },
  {
    path: 'chat',
    loadChildren: './applicationModules/chat/chat.module#ChatModule',
    canActivate: [EcmAuthgaurdGuard],
  },
  {
    path: 'filemanager',
    loadChildren: './applicationModules/file-manager/file-manager.module#FileManagerModule',
    canActivate: [EcmAuthgaurdGuard],
  },
  {
    path: 'request',
    loadChildren: './unAuthenticatedModules/unAuthenticate.module#UnAuthenticateModule',
  },
  {
    path: 'users',
    loadChildren: './applicationModules/users/user.module#UserModule',
    canActivate: [EcmAuthgaurdGuard],
  },
  {
    path: 'moduleMaster',
    loadChildren: './applicationModules/moduleMaster/module-master.module#ModuleMasterModule',
    canActivate: [EcmAuthgaurdGuard],
  },
  {
    path: 'settings',
    loadChildren: './applicationModules/settings/settings.module#SettingsModule',
    canActivate: [EcmAuthgaurdGuard],
  },
  {
    path: 'reports',
    loadChildren: './applicationModules/reports/reports.module#ReportsModule',
    canActivate: [EcmAuthgaurdGuard],
  },
  {
    path: 'admin',
    loadChildren: './applicationModules/admin/admin.module#AdminModule',
    canActivate: [EcmAuthgaurdGuard],
  },
  {
    path: 'verificationError',
    component: ErrorVerificationComponent,
  },
  {
    path: 'unauthorised',
    component: PageNotFoundComponent,
  },
  {
    path: 'gridView',
    component: GroupListingTableComponent,
  },
  {
    path: 'organization',
    loadChildren: './applicationModules/organization/organization.module#OrganizationModule',
    //canActivate: [EcmAuthgaurdGuard],
  },
  {
    path: 'calendar',
    loadChildren: './applicationModules/calendar/calendar.module#CalendarModule',
  },
  {
    path: 'facility',
    loadChildren: './applicationModules/facility/facility.module#FacilityModule',
  },
  {
    path: 'notifications',
    loadChildren: './applicationModules/notification/notification.module#NotificationModule',
  },
 

  {
    path: '**',
    component: PageNotFoundComponent
  }
];

@NgModule({
  //imports: [RouterModule.forRoot(routes)],
  imports: [RouterModule.forRoot(routes, { enableTracing: false, preloadingStrategy: PreloadAllModules })],
  // imports: [RouterModule.forRoot(routes,{useHash:true,enableTracing:false,preloadingStrategy:PreloadAllModules})],
  exports: [RouterModule],
})
export class AppRoutingModule { }
